<template lang="pug">
  .flow-builder-view-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform, platform_index) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white
        p.mb-0 Guardar información
        p.text-secondary.text-sm Te permite guardar un nuevo valor en las variables del usuario.
        b-form-group.mb-2(
          v-if="!disabled",
          label="Buscar:",
          description="Puedes buscar por nombre de variable o valor de la variable.",
        )
          b-input-group
            b-form-input.disabled-white(
              placeholder="Buscar...",
              v-model="search_value",
              type="search"
            )
            b-input-group-append
              b-input-group-text
                search-icon.icon-sm
        b-button.mb-2(variant="link", v-if="hiddenElements.length && !isSearching", @click="showAllUserAttributes = !showAllUserAttributes", :disabled="disabled") {{ !showAllUserAttributes ? `${disabled ? '' : 'Mostrar '}${hiddenElements.length} elementos ocultos` : 'Ocultar elementos' }}
        b-collapse.mb-2(v-model="showAllUserAttributes", :id="`user_attributes_collapse_${template_id}`", v-if="!isSearching")
          save-info-2-element(v-for="(element, element_index) in hiddenElements", :key="element.element_id", v-if="element.type == 'saved_info'", :id="`element_${element.element_id}`", :disabled="disabled", :block_id="block_id", v-bind="element", @destroy="destroyTemplateElement(element)")
        save-info-2-element(v-for="(element, element_index) in visibleElements", :key="element.element_id", v-if="element.type == 'saved_info'", :id="`element_${element.element_id}`", :disabled="disabled", :block_id="block_id", v-bind="element", @destroy="destroyTemplateElement(element)")
        add-element-button(v-if="!disabled", @click="createTemplateElement")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import templateCommon from '@/helpers/template-common'
import SaveInfo2Element from '@/components/templates/SaveInfo2Element.vue'
import AddElementButton from '@/components/AddElementButton.vue'
import TemplateTools from '@/components/templates/common/Tools.vue'
import _debounce from 'lodash.debounce'

const accountController = createNamespacedHelpers('account')

export default {
  mixins: [templateCommon],
  data () {
    return {
      visibleLimit: 3,
      search_value: '',
      showAllUserAttributes: false,
      viewTypes: [
        {
          text: 'Genérica',
          value: 'normal'
        },
        {
          text: 'Personalizada',
          value: 'custom'
        }
      ]
    }
  },
  methods: {
    ...mapActions(['account/userAttributes']),
    getUserAttributes () {
      const self = this

      this['account/userAttributes']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) return this.$message.error('res.error')
        }
      })
    },
  },
  computed: {
    ...accountController.mapState({
      user_attributes: state => state.user_attributes
    }),
    isSearching () {
      return Boolean(this.search_value)
    },
    visibleElements () {
      if (this.isSearching) {
        return this.Elements.filter(e => {
          for (let element_attribute of e.Element_Attributes) {
            if (element_attribute.name === 'user_attribute_value') {
              if ((new RegExp(this.search_value, 'i')).test(element_attribute.value)) return true
            } else if (element_attribute.name === 'user_attribute_id') {
              const user_attribute = this.user_attributes.find(a => a.user_attribute_id == parseInt(element_attribute.value))

              if ((new RegExp(this.search_value, 'i')).test(user_attribute.name)) return true
            }
          }

          return false
        })
      } else {
        return this.Elements.slice(this.visibleLimit * -1)
      }
    },
    hiddenElements () {
      return this.Elements.slice(0, this.visibleLimit * -1)
    }
  },
  components: {
    SaveInfo2Element,
    AddElementButton,
    TemplateTools
  },
  mounted () {
    this.getUserAttributes()
  },
  created () {
    this.createTemplateElement = () => {
      let self = this
      let element = {
        type: 'saved_info',
        number: self.Elements.length + 1,
        attributes: [
          {
            name: 'user_attribute_id',
            value: ''
          },
          {
            name: 'user_attribute_value',
            value: ''
          }
        ],
      }

      this.createElement(this.block_id, this.template_id, element)
    }

    this.destroyTemplateElement = (element) => {
      this.destroyElement(this.block_id, this.template_id, element)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .flow-builder-view-template {
    position: relative;
    flex: 1 0 auto;
    max-width: 100%;
    background-color: transparent;
    white-space: normal;
  }
</style>
